import React, { useState } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";
import Modal from "react-bootstrap/Modal";

function ProjectCards(props) {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  return (
    <>
      <Card className="project-card-view">
        <Card.Img variant="top" src={props.imgPath} alt="card-img" />
        <Card.Body>
          <Card.Title>{props.title}</Card.Title>
          <Button variant="primary" onClick={handleShow}>
            Description
          </Button>
          {!props.isBlog && (
            <div style={{ marginTop: "10px" }}>
              <a href={props.ghLink} target="_blank" rel="noopener noreferrer" style={{ color: "white" }}>
                <BsGithub size={24} style={{ marginRight: "10px", backgroundColor: "black", padding: "5px", borderRadius: "5px" }} />
              </a>
              {props.demoLink && (
                <a href={props.demoLink} target="_blank" rel="noopener noreferrer" style={{ color: "white" }}>
                  <CgWebsite size={24} style={{ backgroundColor: "black", padding: "5px", borderRadius: "5px" }} />
                </a>
              )}
            </div>
          )}
        </Card.Body>
      </Card>

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{props.description}</p>
          {!props.isBlog && (
            <div style={{ marginTop: "10px" }}>
              <a href={props.ghLink} target="_blank" rel="noopener noreferrer" style={{ color: "white" }}>
                <BsGithub size={24} style={{ marginRight: "10px", backgroundColor: "black", padding: "5px", borderRadius: "5px" }} />
              </a>
              {props.demoLink && (
                <a href={props.demoLink} target="_blank" rel="noopener noreferrer" style={{ color: "white" }}>
                  <CgWebsite size={24} style={{ backgroundColor: "black", padding: "5px", borderRadius: "5px" }} />
                </a>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ProjectCards;
